export default () => async (dispatch) => {
  dispatch({
    type: 'SOCIAL/CLEAR_FULL_VIDEO_INFO',
  });
};
